import { ChevronUpIcon } from '@heroicons/react/24/outline';
import Button from '../common/button.tsx';
import { useGetMe } from '../../utils/hooks.ts';
import { GetTestAttemptQuery } from '../../apollo/__generated__/graphql.ts';

interface IProps {
  questions: GetTestAttemptQuery['testAttempt']['getAttempt']['lastModule']['questions'];
  isCheckAnswerScreen: boolean;
  isQuestionsModalOpen: boolean;
  openQuestionsModal: () => void;
  currentQuestionId: number;
  setPrevQuestion: () => void;
  setNextQuestion: () => void;
}

const attemptChromeDashStyle = {
  backgroundImage:
    'linear-gradient(to right, #111111 0 72%, transparent 72% 100%)',
  backgroundRepeat: 'repeat-x',
  backgroundSize: 'calc(100% / 56) 100%',
} as const;

const TestAttemptFooter = ({
  isCheckAnswerScreen,
  isQuestionsModalOpen,
  openQuestionsModal,
  questions,
  currentQuestionId,
  setPrevQuestion,
  setNextQuestion,
}: IProps) => {
  const { user } = useGetMe();
  const questionIndex =
    questions.findIndex((question) => question.id === currentQuestionId) + 1;
  const displayName = (() => {
    const name = user?.name?.trim();
    if (!name) return user?.email || '';

    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length <= 1) return parts[0] || '';

    return `${parts[0]} ${parts[parts.length - 1]}`;
  })();
  const footerButtonClass =
    '!h-10 !w-full !rounded-full !bg-blue !px-0 !py-2 !text-[0.95rem] !font-semibold !leading-none !text-white transition-colors hover:!bg-dark-blue disabled:!bg-disabled';
  return (
    <section
      className={
        'attempt-footer-safe-area relative grid min-h-[88px] w-full shrink-0 grid-cols-[1fr_auto_1fr] items-center bg-[#e7edf7] px-10'
      }
    >
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-[2px]"
        style={attemptChromeDashStyle}
      />

      <div className={'z-[1] flex min-w-0 items-center justify-self-start text-[1.05rem] font-medium leading-none text-black'}>
        <span className="whitespace-nowrap leading-none">{displayName}</span>
      </div>

      <div className="flex items-center justify-center">
        {!isCheckAnswerScreen && (
          <button
            type="button"
            data-questions-toggle
            aria-expanded={isQuestionsModalOpen}
            className="flex h-10 items-center rounded bg-black px-4 py-2 text-white hover:bg-gray"
            onClick={openQuestionsModal}
          >
            Question {questionIndex} of {questions.length}
            <ChevronUpIcon className={`ml-2 h-5 w-5 ${isQuestionsModalOpen ? 'rotate-180' : ''}`} />
          </button>
        )}
      </div>

      <div className={'grid w-44 justify-self-end grid-cols-2 items-center gap-3'}>
        {(isCheckAnswerScreen || currentQuestionId !== questions[0].id) ? (
          <Button
            className={footerButtonClass}
            onClick={setPrevQuestion}
          >
            Back
          </Button>
        ) : <div />}
        <Button className={footerButtonClass} onClick={setNextQuestion}>
          Next
        </Button>
      </div>
    </section>
  );
};
export default TestAttemptFooter;
